import { render } from "./DomainPage.vue?vue&type=template&id=271fd42e"
import script from "./DomainPage.vue?vue&type=script&lang=js"
export * from "./DomainPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__